import { Injectable } from '@angular/core';
import { CameraComponent } from '@modules/shared/dialogs/camera/camera.component';
import { AlertService } from '@services/alert.service';

@Injectable({
  providedIn: 'root',
})
export class CameraService {
  constructor(private readonly alert: AlertService) {}

  openCamera(picture, providedCamera = '', upload = true) {
    const dialogRef$ = this.alert.openDialog$(CameraComponent, {
      panelClass: 'camera-dialog',
      data: { picture, providedCamera, upload },
    });
    return dialogRef$.pipe((d$) => d$);
  }
}
